import {
  isChunkLoadError,
  triggerChunkLoadAutoReload,
  willChunkLoadAutoReload,
} from '@/utils/chunkLoadRetry';
import { useEffect } from 'react';

/** 捕获未进入 React 错误边界的动态 import / 脚本分片失败，自动整页重试 */
export default function ChunkLoadRetryEffect() {
  useEffect(() => {
    const onUnhandledRejection = (e: PromiseRejectionEvent) => {
      if (!isChunkLoadError(e.reason) || !willChunkLoadAutoReload()) return;
      e.preventDefault();
      triggerChunkLoadAutoReload();
    };

    const onError = (e: ErrorEvent) => {
      const t = e.target;
      let url = '';
      if (t instanceof HTMLScriptElement) url = t.src || '';
      else if (t instanceof HTMLLinkElement && t.rel === 'stylesheet') url = t.href || '';
      else return;
      if (!/(chunk|\.async\.)/i.test(url)) return;
      if (!willChunkLoadAutoReload()) return;
      triggerChunkLoadAutoReload();
    };

    window.addEventListener('unhandledrejection', onUnhandledRejection);
    window.addEventListener('error', onError, true);
    return () => {
      window.removeEventListener('unhandledrejection', onUnhandledRejection);
      window.removeEventListener('error', onError, true);
    };
  }, []);
  return null;
}
